import React from 'react';
import { Icon, Typography } from '@saviynt/design-system';
import PropTypes from 'prop-types';

import { LinearProgressBar } from '../../../Common';
import { calculatePercentage, getPercentage } from '../utils';

import './TypeLabel.css';

function TypeLabel({ count, totalCount, label, iconKind, doneLabel, ofLabel }) {
  return (
    <div className='TypeLabel-item'>
      {iconKind && (
        <div className='icon'>
          <Icon
            kind={iconKind}
            color='navy-900'
            size='small'
            className='TypeLabel-itemIcon'
          />
        </div>
      )}
      <div className='TypeLabel-mainContent'>
        <Typography kind='body2-bold' className='TypeLabel-itemLabel'>
          {label}
        </Typography>
        <LinearProgressBar value={calculatePercentage(count, totalCount)} />
        <div className='TypeLabel-progress'>
          <Typography kind='body3' className='TypeLabel-progressNumber'>
            {`${count} ${ofLabel} ${totalCount}`}
          </Typography>
          <Typography kind='body3' className='TypeLabel-progressPercentage'>
            {getPercentage(count, totalCount)}
          </Typography>
          <Typography kind='body3-bold' className='TypeLabel-progressStatus'>
            {doneLabel}
          </Typography>
        </div>
      </div>
    </div>
  );
}

TypeLabel.propTypes = {
  count: PropTypes.number.isRequired,
  totalCount: PropTypes.number.isRequired,
  label: PropTypes.string.isRequired,
  doneLabel: PropTypes.string.isRequired,
  ofLabel: PropTypes.string.isRequired,
  iconKind: PropTypes.string,
};

TypeLabel.defaultProps = { iconKind: null };

export default TypeLabel;
